import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpUtils } from 'common';

@Component({
    selector: 'site-pairing-embed',
    template: require('./site-pairing-embed.html')
})

export default class SitePairingEmbedComponent {
    public iframeUrl;
    constructor(private sanitizer: DomSanitizer){
        this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${HttpUtils.getUiMountPoint()}/hybrid-interconnect-app/site-pairing.html`);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/sitepairing/site-pairing-embed.ts